import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApplepay = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 63,
	height: 40,
	viewBox: "0 0 63 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 7.16418C0.5 3.48365 3.48365 0.5 7.16418 0.5H54.9254C58.6059 0.5 61.5896 3.48365 61.5896 7.16418V32.8358C61.5896 36.5163 58.6059 39.5 54.9254 39.5H7.16418C3.48366 39.5 0.5 36.5163 0.5 32.8358V7.16418Z",
			fill: "#000008",
			stroke: "#D6DCE5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.7844 14.7606C20.1987 14.2425 20.4798 13.5468 20.4056 12.8359C19.7992 12.8661 19.0593 13.236 18.6309 13.7545C18.2462 14.1986 17.9057 14.9234 17.9945 15.6045C18.6752 15.6635 19.3552 15.2642 19.7844 14.7606Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.3979 15.7375C19.4094 15.6786 18.5689 16.2985 18.0968 16.2985C17.6245 16.2985 16.9016 15.7671 16.1197 15.7815C15.102 15.7964 14.1577 16.3718 13.6413 17.287C12.5791 19.1177 13.361 21.8334 14.3939 23.3244C14.8955 24.0621 15.5001 24.8743 16.2966 24.8451C17.0492 24.8156 17.3442 24.3578 18.2591 24.3578C19.1732 24.3578 19.439 24.8451 20.2356 24.8303C21.0618 24.8156 21.5783 24.0923 22.0799 23.3539C22.6554 22.513 22.891 21.7011 22.9058 21.6565C22.891 21.6417 21.3127 21.0363 21.298 19.2207C21.2831 17.7005 22.5372 16.9775 22.5962 16.9326C21.888 15.8852 20.7815 15.7671 20.3979 15.7375Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.0053 13.6802C31.1538 13.6802 32.65 15.1612 32.65 17.3174C32.65 19.4814 31.1231 20.9701 28.9514 20.9701H26.5725V24.7532H24.8538V13.6802L29.0053 13.6802ZM26.5725 19.5274H28.5447C30.0411 19.5274 30.8928 18.7218 30.8928 17.3251C30.8928 15.9286 30.0411 15.1305 28.5524 15.1305H26.5725V19.5274Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.099 22.4588C33.099 21.0468 34.181 20.1797 36.0996 20.0723L38.3094 19.9419V19.3204C38.3094 18.4225 37.7031 17.8854 36.6904 17.8854C35.731 17.8854 35.1324 18.3457 34.9868 19.0671H33.4214C33.5135 17.609 34.7565 16.5347 36.7517 16.5347C38.7084 16.5347 39.9591 17.5707 39.9591 19.1898V24.7532H38.3707V23.4257H38.3325C37.8645 24.3235 36.8438 24.8913 35.7849 24.8913C34.2041 24.8913 33.099 23.9091 33.099 22.4588ZM38.3094 21.7299V21.093L36.3219 21.2157C35.3319 21.2848 34.7719 21.7222 34.7719 22.4128C34.7719 23.1187 35.355 23.5792 36.2452 23.5792C37.4038 23.5792 38.3094 22.7811 38.3094 21.7299Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.4588 27.7229V26.38C41.5814 26.4107 41.8576 26.4107 41.9958 26.4107C42.7631 26.4107 43.1776 26.0884 43.4307 25.2597C43.4307 25.2443 43.5766 24.7686 43.5766 24.7609L40.6607 16.6805H42.4561L44.4975 23.2492H44.528L46.5694 16.6805H48.319L45.2953 25.1752C44.605 27.1321 43.8069 27.7613 42.1341 27.7613C41.9958 27.7613 41.5814 27.7459 41.4588 27.7229Z",
			fill: "white"
		})
	]
});
export default SvgApplepay;
